import { useAuthStore } from "@/state/pinia";

export default [
  {
    path: "/",
    name: "default",
    redirect: "/create"
  },
  {
    path: "/create",
    name: "create",
    meta: { title: "Create Predictions", authRequired: true },
    component: () => import("../views/predictions/create")
  },
  {
    path: "/leaderboard",
    name: "leaderboard",
    meta: { title: "Predictions Leaderboard", authRequired: true },
    component: () => import("../views/predictions/leaderboard")
  },
  {
    path: "/view",
    name: "view",
    meta: { title: "View Predictions", authRequired: true },
    component: () => import("../views/predictions/view")
  },
  {
    path: "/settings",
    name: "settings",
    meta: { title: "User Settings", authRequired: true },
    component: () => import("../views/account/settings")
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        const auth = useAuthStore();
        if (auth.loggedIn) {
          next({ name: "default" });
        } else {
          next();
        }
      }
    }
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/account/logout"),
    meta: {
      title: "Logout",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const auth = useAuthStore();
        auth.invalidateUser(); 
        next({ name: "login" })
      }
    }
  },
 // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  // {
  //   path: "*",
  //   redirect: "404",
  // }, 
];
